import React from 'react';

import { CardNumberElement } from '@stripe/react-stripe-js';
import type { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardNumberElementChangeEvent) => unknown;
};

export function CardNumberElementWrapper({ onChange }: Props): React.JSX.Element {
	return <CardNumberElement options={{ style: { base: { fontSize: '16px' } } }} onChange={onChange} />;
}
